import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import "./patientSafetyDay.css";

const TIMELINE = [
  {
    time: "Tháng 5/2019",
    title: "WHO thành lập Ngày An Toàn Người Bệnh Thế Giới",
    desc: "Đại Hội đồng Y tế Thế giới thông qua nghị quyết WHA72.6, chính thức công nhận ngày 17/9 hằng năm là Ngày An Toàn Người Bệnh Thế Giới, kêu gọi các quốc gia thành viên hành động vì an toàn người bệnh.",
    icon: "📜",
  },
  {
    time: "17/9 hằng năm",
    title: "Chiến dịch \"Thắp Sáng Màu Cam\"",
    desc: "Các công trình, di tích và không gian công cộng trên khắp thế giới được chiếu sáng màu cam — màu biểu tượng của an toàn người bệnh — thể hiện sự đoàn kết toàn cầu vì một nền y tế an toàn hơn.",
    icon: "🔶",
  },
  {
    time: "Chủ đề 2026",
    title: "Chăm sóc an toàn cho các bệnh không lây nhiễm",
    desc: "Đảm bảo người mắc các bệnh không lây nhiễm (tim mạch, đái tháo đường, ung thư, hô hấp mạn tính...) được chăm sóc an toàn, liên tục, chất lượng và lấy người bệnh làm trung tâm trong suốt hành trình điều trị.",
    icon: "🩺",
  },
  {
    time: "2021 – 2030",
    title: "Kế hoạch Hành động An toàn Người bệnh Toàn cầu",
    desc: "WHO đặt mục tiêu đến năm 2030 giảm thiểu tối đa các tổn hại có thể phòng tránh được trong quá trình chăm sóc y tế trên toàn thế giới.",
    icon: "🎯",
  },
];

const FACTS = [
  { num: "1/10", unit: "Người bệnh", label: "bị tổn hại khi điều trị nội trú tại các nước thu nhập cao" },
  { num: "134", unit: "Triệu", label: "sự cố y khoa mỗi năm tại các nước thu nhập thấp và trung bình" },
  { num: "~50%", unit: "", label: "sự cố y khoa có thể phòng tránh được" },
  { num: "17/9", unit: "Hằng năm", label: "Ngày An Toàn Người Bệnh Thế Giới" },
];

export default function PatientSafetyDay() {
  const orbs = useMemo(
    () =>
      Array.from({ length: 26 }, (_, i) => ({
        id: i,
        left: Math.random() * 100,
        delay: Math.random() * 14,
        duration: 10 + Math.random() * 12,
        size: 6 + Math.random() * 16,
        opacity: 0.4 + Math.random() * 0.5,
      })),
    []
  );

  return (
    <div className="psd-page">
      {/* ===== HERO ===== */}
      <section className="psd-hero">
        <div className="psd-hero__bg" />

        {orbs.map((o) => (
          <span
            key={o.id}
            className="psd-rising-orb"
            style={{
              left: `${o.left}%`,
              animationDelay: `${o.delay}s`,
              animationDuration: `${o.duration}s`,
              width: `${o.size}px`,
              height: `${o.size}px`,
              opacity: o.opacity,
            }}
          />
        ))}

        <div className="psd-hero__content">
          <div className="psd-badge">
            <span className="psd-badge__cross" />
          </div>

          <div className="psd-date-badge">
            <span className="psd-date-num">17</span>
            <span className="psd-date-unit">THÁNG 9</span>
          </div>

          <h1 className="psd-title">
            NGÀY AN TOÀN
            <br />
            NGƯỜI BỆNH THẾ GIỚI
          </h1>

          <div className="psd-date-banner">
            Chủ đề 2026: “Safe care for life!” — Chăm sóc an toàn cho cuộc sống!
          </div>

          <p className="psd-subtitle">
            Hưởng ứng Ngày An Toàn Người Bệnh Thế Giới 17/9/2026 với chủ đề
            “Chăm sóc an toàn cho các bệnh không lây nhiễm” — vì một nền y tế
            an toàn, không gây hại cho mọi người bệnh.
          </p>

          <div className="psd-ribbon">
            <div className="psd-ribbon__bar" />
            <span className="psd-ribbon__dot" />
            <div className="psd-ribbon__bar" />
          </div>

          <Link to="/" className="psd-back-btn">
            ← Về trang chủ
          </Link>
        </div>
      </section>

      {/* ===== TIMELINE ===== */}
      <section className="psd-section psd-tl-section">
        <div className="psd-container">
          <h2 className="psd-section-title">
            <span className="psd-title-line" />
            Hành trình An toàn Người bệnh
            <span className="psd-title-line" />
          </h2>

          <div className="psd-timeline">
            <div className="psd-tl-axis" />
            {TIMELINE.map((ev, i) => {
              const isLeft = i % 2 === 0;
              return (
                <div key={i} className="psd-tl-row">
                  {isLeft ? (
                    <>
                      <div className="psd-tl-card psd-tl-card--right">
                        <div className="psd-tl-time">{ev.time}</div>
                        <div className="psd-tl-heading">{ev.title}</div>
                        <div className="psd-tl-desc">{ev.desc}</div>
                      </div>
                      <div className="psd-tl-dot">{ev.icon}</div>
                      <div className="psd-tl-spacer" />
                    </>
                  ) : (
                    <>
                      <div className="psd-tl-spacer" />
                      <div className="psd-tl-dot">{ev.icon}</div>
                      <div className="psd-tl-card psd-tl-card--left">
                        <div className="psd-tl-time">{ev.time}</div>
                        <div className="psd-tl-heading">{ev.title}</div>
                        <div className="psd-tl-desc">{ev.desc}</div>
                      </div>
                    </>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* ===== FACTS ===== */}
      <section className="psd-section psd-facts-section">
        <div className="psd-container">
          <h2 className="psd-section-title">
            <span className="psd-title-line" />
            Sự thật về An toàn Người bệnh
            <span className="psd-title-line" />
          </h2>

          <div className="psd-facts-grid">
            {FACTS.map((a, i) => (
              <div key={i} className="psd-fact-card">
                <div className="psd-fact-num">{a.num}</div>
                {a.unit && <div className="psd-fact-unit">{a.unit}</div>}
                <div className="psd-fact-label">{a.label}</div>
              </div>
            ))}
          </div>

          <p className="psd-facts-source">
            Nguồn: Tổ chức Y tế Thế giới (WHO) — Patient safety fact sheet
          </p>
        </div>
      </section>

      {/* ===== QUOTE ===== */}
      <section className="psd-section psd-quote-section">
        <div className="psd-container">
          <blockquote className="psd-quote">
            <div className="psd-quote__mark">"</div>
            <p className="psd-quote__text">
              Safe care for life! — Chăm sóc an toàn cho cuộc sống!
            </p>
            <footer className="psd-quote__author">
              — Thông điệp chính thức, Ngày An Toàn Người Bệnh Thế Giới 17/9/2026 (WHO)
            </footer>
          </blockquote>
        </div>
      </section>

      {/* ===== FOOTER ===== */}
      <footer className="psd-footer">
        <span className="psd-badge psd-badge--sm">
          <span className="psd-badge__cross" />
        </span>
        <div className="psd-footer-text">
          Hệ thống Y tế Hùng Vương Gia Lai hưởng ứng{" "}
          <strong>Ngày An Toàn Người Bệnh Thế Giới 17/9</strong> — cam kết
          đồng hành cùng người bệnh trên hành trình chăm sóc an toàn.
        </div>
        <span className="psd-badge psd-badge--sm">
          <span className="psd-badge__cross" />
        </span>
      </footer>
    </div>
  );
}
